<template>
  <div class="pageSearchReleaseOrder">
    <h2>{{ $t("pages.wording.searchReleaseOrder") }}</h2>
    <!--查詢放行單Auth-->
    <el-form label-width="150px">
      <h3>{{ $t("pages.wording.searchCondition") }}</h3>
      <!--查詢條件-->
      <div class="boxContain c-form">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.reserveNo')"
              ><!--預約單-->
              <el-input
                v-model.trim="queryItems.reserveNo"
                :placeholder="$t('pages.wording.placeholderInput')"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.releaseNo')"
              ><!--放行單-->
              <el-input
                v-model.trim="queryItems.releaseOrderNo"
                :placeholder="$t('pages.wording.placeholderInput')"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.vendor')"
              ><!--公司名稱-->
              <el-input
                v-model="queryItems.vendor"
                :placeholder="$t('pages.wording.placeholderInput')"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.salesDate')"
              ><!--出售日-->
              <el-date-picker
                v-model="queryItems.reserveDate"
                type="daterange"
                range-separator="-"
                :start-placeholder="$t('pages.wording.startDate')"
                :end-placeholder="$t('pages.wording.endDate')"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                ><!--開始日期/結束日期-->
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.reserveArea')"
              ><!--抵達廠區-->
              <el-select v-model="queryItems.area" clearable :placeholder="$t('pages.wording.placeholderSelect')">
                <el-option v-for="item in base.areaBase" :label="item" :value="item" :key="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.carPlat')"
              ><!--車輛號碼-->
              <el-input
                v-model="queryItems.carPlat"
                :placeholder="$t('pages.wording.placeholderInput')"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.reserveStatus')"
              ><!--狀態-->
              <el-select
                v-model="queryItems.releaseOrderStatus"
                multiple
                :placeholder="$t('pages.wording.placeholderSelect')"
              >
                <el-option
                  v-for="item in base.releaseStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!--boxContain-->
      <div class="buttons c-form">
        <el-button class="blue-button button-right" @click="sentApply" type="primary">{{
          $t("pages.button.search")
        }}</el-button
        ><!--查詢-->
        <el-button v-if="back" class="button-right" @click="cleanSearchVal" type="warning" style="margin-right: 10px">{{
          $t("pages.button.clean")
        }}</el-button
        ><!--清除-->
        <el-button
          class="blue-button button-right"
          :disabled="exportReleaseExcelIsLoading"
          :icon="exportReleaseExcelIsLoading ? 'el-icon-loading' : ''"
          @click="exportExcel"
          type="primary"
          >{{ $t("pages.button.exportExcel") }}</el-button
        ><!--下載Excel-->
      </div>
    </el-form>
    <h3>{{ $t("pages.wording.searchResult") }}</h3>
    <!--查詢結果-->
    <div class="boxContain c-table">
      <el-tabs v-model="activeName">
        <el-tab-pane label="preProcess" name="first">
          <span slot="label"><i class="el-icon-search"></i>{{ $t("pages.wording.searchResult") }}</span
          ><!--查詢結果-->
          <div class="s-table">
            <template>
              <el-table
                :data="releaseNewTableData"
                v-loading="loading"
                highlight-current-row
                @current-change="goReleaseInfoPage"
                border
                style="width: 100%"
                height="450px"
                @sort-change="tableChangeSort"
              >
                <el-table-column label="Action" width="80"
                  ><!--編輯-->
                  <template slot-scope="scope">
                    <div>
                      <el-button type="text" size="medium">
                        <i class="el-icon-tickets"></i>
                      </el-button>
                    </div>
                  </template> </el-table-column
                ><!--編輯-->
                <el-table-column prop="releaseOrderNo" :label="$t('pages.wording.releaseOrder')" width="160">
                </el-table-column
                ><!--放行單-->
                <el-table-column prop="reserveNo" :label="$t('pages.wording.reserveNo')" width="160"> </el-table-column
                ><!--預約單-->
                <el-table-column prop="carPlat" :label="$t('pages.wording.carPlat')" width="140"
                  ><!--車牌號碼-->
                  <template slot-scope="scope">
                    <div v-if="scope.row.tempCar">
                      {{ scope.row.tmpCarPlat }}
                    </div>
                    <div v-if="!scope.row.tempCar">
                      {{ scope.row.carPlat }}
                    </div>
                  </template> </el-table-column
                ><!--車牌-->
                <el-table-column prop="OACode" label="OACode" width="125"> </el-table-column
                ><!--OACode-->
                <el-table-column prop="reserveArea" :label="$t('pages.wording.area')" width="70"> </el-table-column
                ><!--廠區-->
                <el-table-column prop="vendor" :label="$t('pages.wording.vendor')" width="120"> </el-table-column
                ><!--公司名稱-->
                <el-table-column prop="reserveArriveDate" :label="$t('pages.wording.salesDate')" width="130" sortable>
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("Date", scope.row.reserveArriveDatetime) }}
                  </template></el-table-column
                ><!--出售日期-->
                <el-table-column prop="deltaContactName" :label="$t('pages.wording.deltaContactName')" width="230">
                </el-table-column
                ><!--台達聯絡人-->
                <el-table-column prop="applicatorName" :label="$t('pages.wording.applicatorName')" width="100">
                </el-table-column
                ><!--台達聯絡人-->
                <el-table-column prop="releaseOrderStatus" :label="$t('pages.wording.releaseOrderStatus')" width="170">
                  <template slot-scope="scope">
                    {{ $t("release.status." + scope.row.releaseOrderStatus) }}
                  </template> </el-table-column
                ><!--狀態-->
              </el-table>
            </template>
            <el-pagination
              :pager-count="pages.pageCount"
              :page-size="pages.pageSize"
              :current-page.sync="pages.releaseTablePage.pageCurrent"
              layout="prev, pager, next"
              :total="pages.releaseTablePage.pageTotal"
              @current-change="changePageReleaseTable"
            >
            </el-pagination>
          </div>
          <!--s-table-->
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--boxContain-->
  </div>
</template>

<script>
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"
export default {
  name: "PageSearchVendorReleaseOrder",
  props: ["back"],
  data() {
    return {
      readOnly: false,
      activeName: "first",
      userRole: "",
      base: {
        areaBase: [],
        releaseStatus: [
          {
            label: this.$t("release.status.sign"),
            value: "sign",
          },
          {
            label: this.$t("release.status.in1"),
            value: "in1",
          },
          {
            label: this.$t("release.status.in2"),
            value: "in2",
          },
          {
            label: this.$t("release.status.finished"),
            value: "finished",
          },
          {
            label: this.$t("release.status.cancel"),
            value: "cancel",
          },
        ],
      },
      queryItems: {
        reserveNo: "",
        releaseOrderNo: "",
        vendor: "",
        saleDate: [],
        releaseOrderStatus: [],
        reserveDate: [],
        reserveArriveTimeStart: "",
        reserveArriveTimeEnd: "",
        area: "",
        carPlat: "",
      },
      releaseTableData: [],
      releaseNewTableData: [],
      releaseExcel: [],
      pages: {
        pageCount: this.$global.pageCount,
        pageSize: this.$global.pageSize,
        releaseTablePage: {
          pageTotal: 1,
          pageCurrent: 1,
        },
      },
      queryParamsAfterSubmit: {
        reserveNo: "",
        releaseOrderNo: "",
        vendor: "",
        saleDate: [],
        releaseOrderStatus: [],
        area: "",
        carPlat: "",
      },
      loading: false,
      allowQueryReleaseStatusList: ["sign", "in1", "in2", "finished", "cancel"],
      preTabName: "", //keep click tab name for go back action
      exportReleaseExcelIsLoading: false,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getArea()
      //deal with query setting after go back action
      if (
        window.sessionStorage.getItem("queryParams") !== null &&
        window.sessionStorage.getItem("queryParams") !== "null"
      ) {
        let queryParams = JSON.parse(window.sessionStorage.getItem("queryParams"))
        this.queryItems.reserveNo = queryParams.reserveNo
        this.queryItems.releaseOrderNo = queryParams.releaseOrderNo
        this.queryItems.vendor = queryParams.vendor
        this.queryItems.reserveDate = queryParams.reserveDate
        this.queryItems.releaseOrderStatus = queryParams.releaseOrderStatus
        this.queryItems.area = queryParams.area
        this.queryItems.carPlat = queryParams.carPlat
        window.sessionStorage.setItem("queryParams", null)
        this.sentApply()
      }
    },
    changePageReleaseTable(val) {
      this.releaseNewTableData = utils.buildPagingTable(this.releaseTableData, val, this.pages.pageSize)
    },
    tableChangeSort(cols) {
      utils.sortChangeMethod(cols, this.releaseTableData)
      this.releaseNewTableData = utils.buildPagingTable(
        this.releaseTableData,
        this.pages.preProcessTablePage.pageCurrent,
        this.pages.pageSize
      )
    },
    getArea() {
      const paramter = {
        region: null,
        area: null,
      }
      this.$store.dispatch("getArea", { params: paramter })
    },
    async sentApply() {
      const vueInstance = this
      const params = {
        releaseOrderNo: vueInstance.queryItems.releaseOrderNo,
        reserveNo: vueInstance.queryItems.reserveNo,
        releaseOrderStatus:
          vueInstance.queryItems.releaseOrderStatus.length > 0
            ? vueInstance.queryItems.releaseOrderStatus
            : vueInstance.allowQueryReleaseStatusList,
        vendor: vueInstance.queryItems.vendor,
        reserveArea: vueInstance.queryItems.area,
        carPlat: vueInstance.queryItems.carPlat,
      }

      if (vueInstance.queryItems.reserveDate != null && vueInstance.queryItems.reserveDate.length != 0) {
        params.reserveArriveDateTimeStart = utils.getISOString(vueInstance.queryItems.reserveDate[0] + " 00:00")
        params.reserveArriveDateTimeEnd = utils.getISOString(vueInstance.queryItems.reserveDate[1] + " 23:59")
      }

      //keep query parameters after submit query
      vueInstance.queryParamsAfterSubmit.reserveNo = vueInstance.queryItems.reserveNo
      vueInstance.queryParamsAfterSubmit.releaseOrderNo = vueInstance.queryItems.releaseOrderNo
      vueInstance.queryParamsAfterSubmit.releaseOrderStatus = vueInstance.queryItems.releaseOrderStatus
      vueInstance.queryParamsAfterSubmit.vendor = vueInstance.queryItems.vendor
      vueInstance.queryParamsAfterSubmit.reserveDate = vueInstance.queryItems.reserveDate
      vueInstance.queryParamsAfterSubmit.area = vueInstance.queryItems.area
      vueInstance.queryParamsAfterSubmit.carPlat = vueInstance.queryItems.carPlat

      vueInstance.loading = true
      try {
        const { data } = await api.apiGetVendorReleaseTable(params)
        vueInstance.releaseTableData = data
        vueInstance.pages.releaseTablePage.pageTotal = this.releaseTableData.length
        vueInstance.releaseNewTableData = utils.buildPagingTable(
          this.releaseTableData,
          this.pages.releaseTablePage.pageCurrent,
          this.pages.pageSize
        )
        vueInstance.loading = false
      } catch {
        vueInstance.loading = false
      }
    },
    getExcelReleaseTable() {
      //當查詢結果為空時, DownloadExcel為Download所有資料
      const vueInstance = this
      const parameter = {
        releaseOrderNo: vueInstance.queryItems.releaseOrderNo,
        reserveNo: vueInstance.queryItems.reserveNo,
        releaseOrderStatus:
          vueInstance.queryItems.releaseOrderStatus.length > 0
            ? tvueInstancehis.queryItems.releaseOrderStatus
            : vueInstance.allowQueryReleaseStatusList,
        vendor: vueInstance.queryItems.vendor,
        reserveArea: vueInstance.queryItems.area,
        carPlat: vueInstance.queryItems.carPlat,
        IsExportExcel: true,
      }

      if (vueInstance.queryItems.reserveDate != null && vueInstance.queryItems.reserveDate.length != 0) {
        parameter.reserveArriveDateTimeStart = utils.getISOString(this.queryItems.reserveDate[0] + " 00:00")
        parameter.reserveArriveDateTimeEnd = utils.getISOString(this.queryItems.reserveDate[1] + " 23:59")
      }

      return new Promise((resolve) => {
        api.apiGetVendorReleaseTable(parameter).then((response) => {
          resolve(response.data)
        })
      })
    },
    async exportExcel() {
      try {
        this.exportReleaseExcelIsLoading = true
        const vueInstance = this
        let header = new Array()
        header.push([
          vueInstance.$t("pages.wording.releaseOrder"),
          vueInstance.$t("pages.wording.reserveNo"),
          vueInstance.$t("pages.wording.carPlat"),
          vueInstance.$t("pages.wording.oaCode"),
          vueInstance.$t("pages.wording.area"),
          vueInstance.$t("pages.wording.vendor"),
          vueInstance.$t("pages.wording.salesDate"),
          vueInstance.$t("pages.wording.deltaContactName"),
          vueInstance.$t("pages.wording.applicatorName"),
          "SO",
          "SO LINE",
          vueInstance.$t("pages.wording.partName"),
          vueInstance.$t("pages.wording.netWeight"),
          vueInstance.$t("pages.wording.unit"),
          vueInstance.$t("pages.wording.status"),
          "Plant Code",
          "STORAGE.LOC",
        ])

        let excelReleaseTable
        this.releaseExcel = []

        excelReleaseTable = await this.getExcelReleaseTable()
        excelReleaseTable.forEach((item, index) => {
          const obj = {
            放行單: item.releaseOrderNo,
            預約單: item.reserveNo,
            車牌號碼: !item.tempCar ? item.carPlat : item.tmpCarPlat,
            "OA CODE": item.OACode,
            廠區: item.reserveArea,
            公司名稱: item.vendor,
            // "出售日期":item.saleDate,
            出售日期: utils.getFormateDateTime("Date", item.reserveArriveDate),
            台達聯絡人: item.deltaContactName,
            填單人: item.applicatorName,
            SO: item.SO,
            "SO LINE": item.SOLine,
            廢料名稱: item.partNameCN,
            淨重: String(parseFloat(item.netWeight).toFixed(1)).replace(/\.0$/, ""),
            數量單位: item.unit,
            狀態: this.$t("release.status." + item.releaseOrderStatus),
            "Plant Code": item.plantCode,
            "STORAGE.LOC": item.storageLogic,
          }
          this.releaseExcel.push(obj)
        })
        utils.exportExcelWithHeader(
          [header],
          [this.releaseExcel],
          ["data"],
          this.$t("pages.wording.ReleaseRoot") + " " + this.$t("pages.wording.searchResult")
        )
        this.exportReleaseExcelIsLoading = false
      } catch (e) {
        console.error(e)
        this.exportReleaseExcelIsLoading = false
      }
    },
    goReleaseInfoPage(val) {
      //keep params of query for go back.
      const prevPageParams = {
        routeName: "PageSearchVendorReleaseOrder",
        key: {},
      }
      val["queryParams"] = this.queryParamsAfterSubmit
      val["prevPageParams"] = prevPageParams
      this.$router.push({
        name: "PageVendorReleaseOrderInfo",
        params: val,
      })
    },
    formateDatetimeStr(type, dtstring) {
      return utils.getFormateDateTime(type, dtstring)
    },
  },
  watch: {},
  watch: {
    "$store.getters.areaBase": function (val) {
      this.base.areaBase = val
    },
  },
}
</script>

<style>
.pageSearchReleaseOrder .button-right {
  margin-right: 10px;
}
</style>
